import { render, staticRenderFns } from "./BadgeButton.vue?vue&type=template&id=ae8194b4"
import script from "./BadgeButton.vue?vue&type=script&lang=js"
export * from "./BadgeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports